import { Button, Group, Icon, useToast } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import React from 'react';
import { Field, Form } from '~/app/shared/components/Form';
import { HelpDrawerView } from '~/app/shared/components/Help/HelpDrawerView';
import { IllustrationSupportMan } from '~/app/shared/components/Help/phone/IllustrationSupportMan';

const SUPPORT_PHONE = '88 20 48 40';

export function PhoneView(): React.JSX.Element {
    const toast = useToast();

    function submitForm(values: unknown) {
        console.log('handle submit', values);
    }

    function copyPhoneToClipboard() {
        try {
            navigator.clipboard.writeText(SUPPORT_PHONE);
            toast(t`Phone number copied to clipboard!`, { autoClose: 3000, type: 'success' });
        } catch (err) {
            toast(t`Could not copy phone number to clipboard`, { autoClose: 10000, type: 'error' });
        }
    }

    return (
        <HelpDrawerView title={<Trans>Send us a mail</Trans>}>
            <div className="p-4 overflow-auto flex-1">
                <div className="text-center flex flex-col items-center">
                    <IllustrationSupportMan className="mb-8 w-full" />

                    <h4 className="mb-0">
                        <Trans>Call our support</Trans>
                    </h4>
                    <h3 className="inline-flex items-center mb-4">
                        <Button
                            appearance="discrete"
                            className="leading-6 pr-0"
                            type="button"
                            onClick={() => copyPhoneToClipboard()}>
                            {SUPPORT_PHONE}
                            <Icon name="copy" className="text-xs" />
                        </Button>
                    </h3>
                </div>
                <div className="flex items-center gap-2">
                    <hr className="grow" />
                    <Trans>OR</Trans>
                    <hr className="grow" />
                </div>
                <h4 className="text-center">
                    <Trans>Request a call</Trans>
                </h4>
                <p>
                    <Trans>
                        Fill in the number you want us to call you on and we will get back to you as soon as the next supporter is
                        available
                    </Trans>
                </p>
                <Form id="helpPhoneForm" onSubmit={submitForm} messages={{ success: t`Thanks for the request` }}>
                    <Group className="items-end">
                        <div className="grow">
                            <Field.Text label={t`Phone number`} name="phone" required />
                        </div>
                        <Button appearance="default" type="submit" form="helpPhoneForm" className="mb-4 items-center">
                            <Trans>Request a call</Trans>
                        </Button>
                    </Group>
                </Form>
            </div>
        </HelpDrawerView>
    );
}
